import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppBar, Box, Toolbar, IconButton, Typography, Button } from "@mui/material";
import { Menu, AccountCircleSharp, Logout } from "@mui/icons-material";
import TemporaryDrawer from "./TemporaryDrawer";
import { useNavigate } from "react-router-dom";
import Logo from '../../assets/newLogo.png'
import { logOut } from "../../features/auth/authSlice";

const Navbar = () => {
    const { isAuth } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const openDrawer = (event) => {
        if(event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
        setOpen(true);
    }
    const closeDrawer = () => setOpen(false);
    const navigate = useNavigate();
    return(
        <Box sx={{ flexGrow: 1, marginBottom: '1em' }}>
            <AppBar position="static" color="inherit">
                <Toolbar>
                    <IconButton 
                        sx={{ mr: '0.2em' }}
                        edge="start"
                        aria-label="menu"
                        onClick={(e) => openDrawer(e)}
                    >
                        <Menu />
                    </IconButton>
                    <Typography
                        component={'img'}
                        src={Logo}
                        sx={{ width: '16em', cursor: 'pointer' }}
                        onClick={() => navigate('/')}
                        noWrap
                    />
                    <div style={{ flexGrow: 1 }} />
                    <Button 
                        endIcon={ isAuth ? <Logout /> : <AccountCircleSharp />  }
                        variant="outlined"
                        color={ isAuth ? 'secondary' : "success" }
                        onClick={() => { isAuth ? dispatch(logOut()) : navigate('/login')}}
                    >
                        {isAuth ? 'Salir' : 'Acceder'}
                    </Button>
                </Toolbar>
            </AppBar>
            { open && <TemporaryDrawer open={open} close={closeDrawer} openDrawer={openDrawer} navigate={navigate}/> }
        </Box>
    )
}

export default Navbar;